import styled from '@emotion/styled/macro';
import { BaseButton, Variables } from '@enter/core';

export const SubCategoryDelete = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 32px;
    justify-content: flex-end;
    transition: all 0.5s;
`;

export const SubCategoryDefault = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: flex-end;
    align-items: flex-start;
`;

export const SubCategoryConfirm = styled.div`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    justify-content: space-between;
    align-items: flex-end;
`;

export const Button = styled(BaseButton)`
    &:hover {
        color: ${Variables.Colors.white};
        background-color: ${Variables.Colors.warning};
    }
`;

export const ConfirmButton = styled(BaseButton)`
    background-color: ${Variables.Colors.warning};
    &:hover {
        background-color: ${Variables.Colors.r50};
    }
`;

export const Note = styled.span`
    margin-top: 8px;
`;
